import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getOr } from 'lodash/fp';
import membershipApi from './api';

const name = 'memberships';

const getMembershipConfig = createAsyncThunk(
  'memberships/getMembershipConfig',
  async (params) => {
    return membershipApi.getMembershipConfig(params);
  }
);

const checkIn = createAsyncThunk(
  'memberships/checkIn',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.checkIn(payload);
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const register = createAsyncThunk(
  'memberships/register',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.register({ data: payload });
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
const registerWithImage = createAsyncThunk(
  'memberships/registerWithImage',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.registerWithImage(payload);
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
const addSecondaryMember = createAsyncThunk(
  'memberships/addSecondaryMember',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.addSecondaryMember({ data: payload });
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
const addSecondaryMemberWithImage = createAsyncThunk(
  'memberships/addSecondaryMemberWithImage',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.addSecondaryMemberWithImage(payload);
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
const updateMemberPhoto = createAsyncThunk(
  'memberships/updateMemberPhoto',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.updateMemberPhoto(payload);
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
const createSubscription = createAsyncThunk(
  'memberships/createSubscription',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.createSubscription({ data: payload });
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
const cancelRequest = createAsyncThunk(
  'memberships/cancelRequest',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.cancelRequest(payload);
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
const cancelMembership = createAsyncThunk(
  'memberships/cancelMembership',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.cancelMembership(payload);
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const validateMembershipCode = createAsyncThunk(
  'memberships/validateMembershipCode',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.validateMembershipCode({ data: payload });
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
const resetMembership = createAsyncThunk(
  'memberships/resetMembership',
  async () => {
    return true;
  }
);
const updateMembershipCardOnFile = createAsyncThunk(
  'memberships/updateMembershipCardOnFile',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.updateMembershipCardOnFile({ data: payload });
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
const restartMembership = createAsyncThunk(
  'memberships/restartMembership',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.restartMembership({ data: payload });
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const restartChangePlanRequest = createAsyncThunk(
  'memberships/restartChangePlanRequest',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.restartChangePlanRequest(payload);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const restartChangePlanConfirm = createAsyncThunk(
  'memberships/restartChangePlanConfirm',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.restartChangePlanConfirm(payload);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
const cardOnFileInfo = createAsyncThunk(
  'memberships/cardOnFileInfo',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.cardOnFileInfo(payload);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const cardOnFileUpdate = createAsyncThunk(
  'memberships/cardOnFileUpdate',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.cardOnFileUpdate(payload);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const cardOnFileDelete = createAsyncThunk(
  'memberships/cardOnFileDelete',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.cardOnFileDelete(payload);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const resendMembershipEmail = createAsyncThunk(
  'memberships/resendMembershipEmail',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.resendMembershipEmail({ data: payload });
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
const sendRestartMembershipEmail = createAsyncThunk(
  'memberships/sendRestartMembershipEmail',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.sendRestartMembershipEmail({ data: payload });
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
const getMembershipFreeItemConfig = createAsyncThunk(
  'memberships/getMembershipFreeItemConfig',
  async (params) => {
    return membershipApi.getMembershipFreeItemConfig(params);
  }
);

const getMembershipByCode = createAsyncThunk(
  'memberships/getMembershipByCode',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.getMembershipByCode(payload);
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const getMembershipFreeItem = createAsyncThunk(
  'memberships/getMembershipFreeItem',
  async (params) => {
    return membershipApi.getMembershipFreeItem(params);
  }
);

const createMembershipFreeItem = createAsyncThunk(
  'membership/createMembershipFreeItem',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.createMembershipFreeItem({ data: payload });
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const { actions, reducer } = {
  ...createSlice({
    name,
    initialState: {
      isLoading: false,
      configs: {},
      membership: {},
      freeItemConfigs: [],
      freeItems: [],
    },
    reducers: {},

    extraReducers: (builder) => {
      const setLoading = (state) => {
        state.isLoading = true;
      };
      const setError = (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      };

      builder
        // Membership config
        .addCase(getMembershipConfig.pending, setLoading)
        .addCase(getMembershipConfig.fulfilled, (state, action) => {
          state.isLoading = false;
          state.configs = action.payload;
        })
        .addCase(getMembershipConfig.rejected, setError)

        // Check-in
        .addCase(checkIn.pending, setLoading)
        .addCase(checkIn.fulfilled, (state, action) => {
          state.isLoading = false;
          state.membership = action.payload;
        })
        .addCase(checkIn.rejected, (state, action) => {
          state.isLoading = false;
          state.membership = { error: action };
        })

        // Get membership by code
        .addCase(getMembershipByCode.pending, setLoading)
        .addCase(getMembershipByCode.fulfilled, (state, action) => {
          state.isLoading = false;
          state.membership = action.payload;
        })
        .addCase(getMembershipByCode.rejected, (state, action) => {
          state.isLoading = false;
          state.membership = { error: action };
        })

        // Reset
        .addCase(resetMembership.fulfilled, (state) => {
          state.isLoading = false;
          state.membership = {};
        })

        // Free item config
        .addCase(getMembershipFreeItemConfig.pending, setLoading)
        .addCase(getMembershipFreeItemConfig.fulfilled, (state, action) => {
          state.isLoading = false;
          state.freeItemConfigs = action.payload;
        })
        .addCase(getMembershipFreeItemConfig.rejected, setError)

        // Free items
        .addCase(getMembershipFreeItem.pending, setLoading)
        .addCase(getMembershipFreeItem.fulfilled, (state, action) => {
          state.isLoading = false;
          state.freeItems = action.payload;
        })
        .addCase(getMembershipFreeItem.rejected, setError)

        // Create free item
        .addCase(createMembershipFreeItem.pending, setLoading)
        .addCase(createMembershipFreeItem.fulfilled, (state) => {
          state.isLoading = false;
        })
        .addCase(createMembershipFreeItem.rejected, setError);
    },
  }),
};

const validateSignUpCoupon = createAsyncThunk(
  'memberships/validateSignUpCoupon',
  async (payload, { rejectWithValue }) => {
    try {
      return await membershipApi.validateSignUpCoupon({ data: payload });
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
const selectors = {
  selectIsLoading: (state) => getOr(false, 'isLoading', state[name]),
  selectConfigs: (state) => getOr({}, 'configs', state[name]),
  selectFreeItemConfig: (state) => getOr({}, 'freeItemConfigs', state[name]),
  selectFreeItems: (state) => getOr({}, 'freeItems', state[name]),
  selectDetails: (state) => getOr({}, 'membership', state[name]),
};

export default {
  actions: {
    ...actions,
    getMembershipConfig,
    validateMembershipCode,
    validateSignUpCoupon,
    checkIn,
    resetMembership,
    register,
    registerWithImage,
    addSecondaryMember,
    addSecondaryMemberWithImage,
    updateMemberPhoto,
    createSubscription,
    cancelRequest,
    cancelMembership,
    updateMembershipCardOnFile,
    restartMembership,
    restartChangePlanRequest,
    restartChangePlanConfirm,
    cardOnFileInfo,
    cardOnFileUpdate,
    cardOnFileDelete,
    resendMembershipEmail,
    sendRestartMembershipEmail,
    getMembershipFreeItemConfig,
    getMembershipFreeItem,
    createMembershipFreeItem,
    getMembershipByCode,
  },
  selectors,
  reducer,
  name,
};
